<template>
  <div style="width: 100%; heigh: 100%" id="chechConf">
    <div class="table_searchbar">
      <el-row :gutter="20">
        <el-col :span="span">
          <div class="" @keydown.enter="btnSearch()">
            <span class="title">点检名称：</span>
            <el-input
              size="small"
              style="max-width: 180px"
              v-model="searchForm.configName"
              maxlength="16"
              placeholder="点检名称"
            ></el-input>
          </div>
        </el-col>
        <el-col :span="span">
          <div class="">
            <span class="title">使用级别：</span>
            <el-select
              size="small"
              style="max-width: 180px"
              v-model="searchForm.workingLevel"
              placeholder="使用级别"
            >
              <el-option
                v-for="item in levelOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </el-col>
        <el-col :span="24 - 2 * span">
          <div style="text-align: right">
            <el-button
              size="mini"
              icon="el-icon-search"
              type="primary"
              @click="btnSearch()"
              >查询</el-button
            >
            <el-button size="mini" icon="el-icon-refresh" @click="clearSearch"
              >重置</el-button
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="table_common_operbar" v-if="permission.btn_inspectionConfig_add">
      <el-row>
        <el-button
          icon="el-icon-plus"
          type="primary"
          size="small"
          @click="addWindowShow()"
          >新增点检</el-button
        >
      </el-row>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="deviceTable y_Public_table"
    >
      <el-table-column prop="configName" label="点检名称" min-width="160">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.configName"
            placement="top-start"
          >
            <div class="y_clamp">
              <div>{{ scope.row.configName }}</div>
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column
        prop="deviceTypeId"
        label="设备类型"
        :formatter="parseDeviceType"
        min-width="110"
      ></el-table-column>
      <el-table-column
        prop="workingLevel"
        label="使用级别"
        :formatter="parseLeve"
        min-width="110"
      ></el-table-column>
      <el-table-column
        prop="gmtCreate"
        label="创建时间"
        :formatter="parseDate"
      ></el-table-column>
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="showViewDialog(scope.row)"
            v-if="permission.btn_inspectionConfig_getDetai"
            size="small"
            >查看</el-button
          >
          <el-button
            type="text"
            @click="showEditDialog(scope.row)"
            v-if="permission.btn_inspectionConfig_update"
            size="small"
            >编辑</el-button
          >
          <el-button
            type="text"
            @click="deleteConfig(scope.row)"
            v-if="permission.btn_inspectionConfig_delete"
            size="small"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="page" v-if="tableData.length > 0">
      <div class="total_page">
        <span> 共{{ tableTotalPage }}条 10条/页</span>
      </div>
      <div style="margin-top: 10px; text-align: right; margin-bottom: 20px">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="tableTotalPage"
          @current-change="pageChange"
          :current-page="tableCurrentPage"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 新增点检点检开始 -->
    <el-dialog
      title="新增点检配置"
      @close="cancelAddDialog"
      :visible.sync="addDialogVisible"
      :width="span == 5 ? '45%' : '64%'"
      center
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        :rules="rules"
        ref="addForm"
        style="width: 100%"
        class="add_form"
      >
        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="8">
            <span class="titel">点检名称：</span>
            <el-form-item prop="configName" class="value" :rules="rules.configName">
              <el-input
                ref="focusinput"
                size="small"
                style="max-width: 180px"
                v-model="addForm.configName"
                maxlength="16"
                placeholder="点检名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <span class="titel">使用级别：</span>
            <el-form-item class="value" prop="workingLevel" style="max-width: 180px">
              <el-select
                size="small"
                v-model="addForm.workingLevel"
                placeholder="使用级别"
                style="display: block"
              >
                <el-option
                  v-for="item in levelOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <span class="titel">设备类型：</span>
            <el-form-item class="value" prop="deviceTypeId" style="max-width: 180px">
              <el-select
                size="small"
                v-model="addForm.deviceTypeId"
                placeholder="设备类型"
                style="display: block"
              >
                <el-option
                  v-for="item in deviceType"
                  :key="item.id"
                  :label="item.deviceType"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px">
          <el-col :span="24">
            <el-button type="primary" @click="addDetailList()">新增点检配置项</el-button>
          </el-col>
        </el-row>
        <el-table
          class="check-list"
          :data="addForm.detailList"
          Height="457"
          style="width: 100%; margin-bottom: 10px; overflow-y: auto; max-height: 457px"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <el-form-item>
                <span>{{ scope.$index + 1 }}</span>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="点检内容" prop="content" width="200">
            <template slot-scope="scope">
              <el-form-item
                :prop="'detailList[' + scope.$index + '].content'"
                :rules="rules.content"
              >
                <el-input
                  :ref="`focusprocedure${scope.$index}`"
                  size="small"
                  maxlength="50"
                  v-model="addForm.detailList[scope.$index].content"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="检查方式" width="100">
            <template slot-scope="scope">
              <el-form-item>
                <el-select
                  class="input-min-width"
                  size="small"
                  v-model="addForm.detailList[scope.$index].inspectWay"
                  placeholder="检查方式"
                  style="display: block"
                >
                  <el-option
                    v-for="item in actType"
                    :checked="true"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="检查标准">
            <template slot-scope="scope">
              <el-form-item
                :prop="'detailList[' + scope.$index + '].criterion'"
                :rules="rules.criterion"
              >
                <el-input
                  autosize
                  type="textarea"
                  size="small"
                  maxlength="50"
                  :show-word-limit="true"
                  v-model="addForm.detailList[scope.$index].criterion"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <el-form-item>
                <div
                  class="delete"
                  type="primary"
                  @click="removeDetail(scope.$index)"
                ></div>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddDialog">添 加</el-button>
        <el-button @click="cancelAddDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 新增点检点检结束 -->

    <!-- 编辑点检点检开始 -->
    <el-dialog
      title="编辑点检配置"
      @close="cancelEditDialog"
      :visible.sync="editDialogVisible"
      :width="span == 5 ? '45%' : '64%'"
      center
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        :rules="rules"
        ref="editForm"
        style="width: 100%"
        class="add_form"
      >
        <el-row :gutter="20" style="margin-bottom: 0px">
          <el-col :span="8">
            <span class="titel">点检名称：</span>
            <el-form-item prop="configName" class="value" :rules="rules.configName">
              <el-input
                size="small"
                style="max-width: 180px"
                v-model="addForm.configName"
                maxlength="16"
                placeholder="点检名称"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <span class="titel">使用级别：</span>
            <el-form-item class="value" prop="workingLevel" style="max-width: 180px">
              <el-select
                size="small"
                v-model="addForm.workingLevel"
                placeholder="使用级别"
                style="display: block"
              >
                <el-option
                  v-for="item in levelOption"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <span class="titel">设备类型：</span>
            <el-form-item class="value" style="max-width: 180px">
              <span>{{ addForm.deviceType }}</span>
              <!-- <el-select size="small"  v-model="addForm.deviceTypeId" placeholder="设备类型" filterable style="display:block">
                                <el-option v-for="item in deviceType" :key="item.id" :label="item.name" :value="item.id">
                                </el-option>
                            </el-select> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20" style="margin-top: 10px">
          <el-col :span="24">
            <el-button type="primary" @click="addDetailList()">新增点检配置项</el-button>
          </el-col>
        </el-row>
        <el-table
          class="check-list"
          :data="addForm.detailList"
          Height="457"
          style="width: 100%; margin-bottom: 10px; overflow-y: auto; max-height: 457px"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <el-form-item>
                <span>{{ scope.$index + 1 }}</span>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="点检内容" prop="content" width="200">
            <template slot-scope="scope">
              <el-form-item
                :prop="'detailList[' + scope.$index + '].content'"
                :rules="rules.content"
              >
                <el-input
                  :ref="`focusprocedure${scope.$index}`"
                  size="small"
                  maxlength="50"
                  v-model="addForm.detailList[scope.$index].content"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="检查方式" width="100">
            <template slot-scope="scope">
              <el-form-item>
                <el-select
                  class="input-min-width"
                  size="small"
                  v-model="addForm.detailList[scope.$index].inspectWay"
                  placeholder="检查方式"
                  style="display: block"
                >
                  <el-option
                    v-for="item in actType"
                    :checked="true"
                    :key="item"
                    :label="item"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="检查标准">
            <template slot-scope="scope">
              <el-form-item
                :prop="'detailList[' + scope.$index + '].criterion'"
                :rules="rules.criterion"
              >
                <el-input
                  :autosize="{ minRows: 1, maxRows: 3 }"
                  type="textarea"
                  maxlength="50"
                  size="small"
                  :show-word-limit="true"
                  v-model="addForm.detailList[scope.$index].criterion"
                ></el-input>
              </el-form-item>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="60">
            <template slot-scope="scope">
              <el-form-item>
                <div
                  class="delete"
                  type="primary"
                  @click="removeDetail(scope.$index)"
                ></div>
              </el-form-item>
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEditDialog">保 存</el-button>
        <el-button @click="cancelEditDialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 编辑点检点检结束 -->

    <!-- 查看点检点检开始 -->
    <el-dialog
      title="查看点检配置"
      @close="cancelViewDialog"
      :visible.sync="viewDialogVisible"
      :width="span == 5 ? '45%' : '64%'"
      center
      :close-on-click-modal="false"
    >
      <el-form style="width: 100%" class="add_form">
        <el-row :gutter="20" style="margin-bottom: 30px">
          <el-col :span="8">
            <span class="titel">点检名称：</span>
            <span>{{ addForm.configName }}</span>
          </el-col>
          <el-col :span="8">
            <span class="titel">使用级别：</span>
            <span>{{ addForm.workingLevel }}</span>
          </el-col>
          <el-col :span="8">
            <span class="titel">设备类型：</span>
            <span>{{ addForm.deviceTypeId }}</span>
          </el-col>
        </el-row>

        <el-table
          class="check-list"
          :data="addForm.detailList"
          style="width: 100%; margin-bottom: 10px; overflow-y: auto; max-height: 450px"
        >
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="点检内容" prop="content" width="200"> </el-table-column>
          <el-table-column label="检查方式" width="100" prop="inspectWay">
          </el-table-column>
          <el-table-column label="检查标准" prop="criterion"> </el-table-column>
        </el-table>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelViewDialog" type="primary">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 新增点检配置结束 -->
  </div>
</template>

<script>
export default {
  name: "CheckConf",
  data() {
    return {
      CNmouserShow: null,
      fristLoad: false,
      viewDialogVisible: false,
      editDialogVisible: false,
      actType: ["目视", "耳听", "鼻嗅", "手触", "口尝", "其他", "综合"],
      levelOption: [
        { label: "一级", value: 1 },
        { label: "二级", value: 2 },
        { label: "三级", value: 3 },
      ],
      deviceType: [
        {
          id: 1,
          name: "车床",
        },
        {
          id: 2,
          name: "铣床",
        },
        {
          id: 3,
          name: "加工中心",
        },
        {
          id: 4,
          name: "锯床",
        },
        {
          id: 5,
          name: "磨床",
        },
        {
          id: 6,
          name: "钻床",
        },
        {
          id: 7,
          name: "拉丝机",
        },
        {
          id: 8,
          name: "摇臂钻",
        },
        {
          id: 9,
          name: "焊机",
        },
        {
          id: 10,
          name: "攻丝机",
        },
        {
          id: 11,
          name: "刨床",
        },
        {
          id: 12,
          name: "剪板机",
        },
        {
          id: 13,
          name: "折弯机",
        },
        {
          id: 14,
          name: "喷砂机",
        },
        {
          id: 16,
          name: "水车式专机",
        },
        {
          id: 15,
          name: "其它",
        },
      ],
      W: false,
      btnPressType: 0, //按钮类型： 0-默认 1-查询 2-重置 3-分页
      searchFormTemp: "", //临时搜索数据
      searchForm: {
        workingLevel: null,
        configName: "",
      },
      addForm: {
        configName: "",
        workingLevel: "",
        deviceTypeId: null,
        detailList: [],
      },
      viewForm: {},
      tableData: [],
      tableCurrentPage: 1,
      tableTotalPage: 2,
      addDialogVisible: false,
      editDialogVisible: false,
      viewDialogVisible: false,
      qrCodeDialogVisible: false,
      qrCode: null,
      qrDeviceCode: "",
      qrDeviceName: "",
      data: {
        token: localStorage.getItem("token"),
      },
      rules: {
        configName: [
          { required: true, message: "请输入点检名称", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value.trim().length == 0) {
                callback(new Error("点检名称不能为空"));
              } else {
                if (value.trim().length != value.length) {
                  callback(new Error("点检名称不能以空格开始或结束"));
                } else {
                  callback();
                }
              }
            },
            trigger: "blur",
          },
        ],
        content: [{ required: true, message: "请输入检点内容", trigger: "blur" }],
        criterion: [{ required: true, message: "请输入检查标准", trigger: "blur" }],
        workingLevel: [{ required: true, message: "请选择保养级别", trigger: "blur" }],
        deviceTypeId: [{ required: true, message: "请选择设备类型", trigger: "blur" }],
      },
      permission: JSON.parse(localStorage.getItem("permission")),
    };
  },
  mounted: function () {
    this.initTable();
    let w = document.documentElement.clientWidth || document.body.clientWidth;
    w >= 1900 ? (this.W = true) : (this.W = false);
    window.onresize = () => {
      let w = document.documentElement.clientWidth || document.body.clientWidth;
      w >= 1900 ? (this.W = true) : (this.W = false);
    };
    this.loadDeviceTypeList();
  },
  computed: {
    span() {
      return this.W ? 5 : 7;
    },
  },
  deactivated: function () {
    console.log("deactivated");
  },
  methods: {
    async loadDeviceTypeList() {
      let { data, code, msg, message } = await this.$RequestUtil.getAsync({
        url: "/api/device/listDeviceType",
        type: "sync",
        params: {},
      });
      if (code == 0) {
        this.deviceType = data;
      } else {
        this.$message.error(msg || message);
      }
    },
    deleteConfig(rowData) {
      this.$confirm("此操作将删除该点检配置, 删除后不可撤销，是否继续?", "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$RequestUtil.post({
          url: "/api/deviceInspectionConfig/deleteConfig",
          type: "sync",
          params: {
            id: rowData.id,
          },
          success: (res) => {
            if (res.code != -1) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.search(1);
            }
          },
        });
      });
    },
    parseDeviceType(rowData) {
      let num = Number(rowData.deviceTypeId);
      let str = "";
      this.deviceType.forEach((item) => {
        if (item.id == num) {
          str = item.deviceType;
        }
      });
      return str;
    },
    parseLeve(rowData) {
      let num = Number(rowData.workingLevel);
      let str = "";
      switch (num) {
        case 1:
          str = "一级";
          break;
        case 2:
          str = "二级";
          break;
        case 3:
          str = "三级";
          break;
      }
      return str;
    },
    cancelEditDialog() {
      this.$refs["editForm"].clearValidate();
      this.editDialogVisible = false;
      this.addForm = {
        configName: "",
        workingLevel: "",
        deviceTypeId: null,
        id: null,
        detailList: [],
        oldDeviceTypeId: null,
      };
    },
    cancelViewDialog() {
      this.viewDialogVisible = false;
      this.addForm = {
        configName: "",
        workingLevel: "",
        deviceTypeId: null,
        id: null,
        detailList: [],
      };
    },
    removeDetail(rowIndex) {
      this.addForm.detailList.splice(rowIndex, 1);
    },
    addDetailList() {
      let json = {};
      json.inspectWay = "目视";
      json.id = null;
      json.configId = null;
      let index = this.addForm.detailList.length;
      this.addForm.detailList.push(json);
      setTimeout(() => {
        this.$refs[`focusprocedure${index}`].focus();
      }, 0);
    },
    cancelAddDialog() {
      this.$refs["addForm"].clearValidate();
      this.addDialogVisible = false;
      this.addForm = {
        configName: "",
        workingLevel: "",
        deviceTypeId: null,
        detailList: [],
      };
    },
    submitAddDialog() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          if (this.addForm.detailList.length == 0) {
            this.$message.warning("点检配置项不能为空");
            return;
          }
          this.$RequestUtil.post({
            url: "/api/deviceInspectionConfig/addConfig",
            type: "sync",
            params: this.addForm,
            success: (res) => {
              log("", res);
              if (res.code == 0) {
                log(1111);
                this.$message.success("添加成功");
                this.addDialogVisible = false;
                this.initTable();
                this.addForm = {
                  configName: "",
                  workingLevel: "",
                  deviceTypeId: null,
                  detailList: [],
                };
              } else {
                this.$message.error(res.message);
              }
            },
          });
        }
        log(this.addForm);
        console.log("提交", valid);
      });
    },
    submitEditDialog() {
      this.$refs["editForm"].validate((valid) => {
        if (valid) {
          if (this.addForm.detailList.length == 0) {
            this.$message.warning("点检配置项不能为空");
            return;
          }
          this.addForm.deviceTypeId = this.addForm.oldDeviceTypeId;
          this.$RequestUtil.post({
            url: "/api/deviceInspectionConfig/updateConfig",
            type: "sync",
            params: this.addForm,
            success: (res) => {
              if (res.code == 0) {
                this.$message.success("编辑成功");
                this.editDialogVisible = false;
                this.initTable();
                this.addForm = {
                  configName: "",
                  workingLevel: "",
                  deviceTypeId: null,
                  id: null,
                  detailList: [],
                  oldDeviceTypeId: null,
                };
              } else {
                this.$message.error(res.message);
              }
            },
          });
        }
        log(this.addForm);
        console.log("提交", valid);
      });
    },
    btnSearch: function () {
      this.tableCurrentPage = 1;
      this.btnPressType = 1;
      this.search();
    },
    clearSearch() {
      let form = this.searchForm;
      this.btnPressType = 2;
      form.configName = "";
      form.workingLevel = null;
    },
    search: function () {
      let temp;
      switch (this.btnPressType) {
        case 1:
          temp = commonUtils.cloneObj(this.searchForm);
          this.searchFormTemp = commonUtils.cloneObj(temp);
          break;
        case 0:
          temp = {
            configName: "",
            workingLevel: "",
          };
          break;
        case 2:
          temp = this.searchFormTemp;
          break;
        case 3:
          temp = this.searchFormTemp;
          break;
      }
      this.$RequestUtil.get({
        url: "/api/deviceInspectionConfig/listConfig",
        type: "sync",
        params: {
          pageNum: this.tableCurrentPage,
          pageSize: 10,
          configName: temp.configName,
          workingLevel: temp.workingLevel,
        },
        success: (res) => {
          if (res.msg == this.$Global.RESPONSE.SUCCESS) {
            this.tableData = res.data;
            this.tableTotalPage = res.totalPages;
            if (res.totalPages == 0 && this.fristLoad) {
              this.$message.warning("查询不到符合条件的数据");
            }
            this.fristLoad = true;
          } else {
            this.$message.error(res.msg || res.message);
          }
        },
      });
    },
    pageChange: function (targetPage) {
      this.tableCurrentPage = targetPage;
      this.btnPressType = 3;
      this.search();
    },
    initTable: function () {
      this.search();
    },
    addWindowShow: function () {
      this.addDialogVisible = true;
      setTimeout(() => {
        this.$refs.focusinput.focus();
      }, 0);
    },
    showEditDialog: function (rowData) {
      this.editDialogVisible = true;
      this.addForm.configName = rowData.configName;
      this.addForm.detailList = commonUtils.cloneObj(rowData.detailList);
      this.addForm.oldDeviceTypeId = rowData.deviceTypeId;
      this.addForm.deviceType = this.parseDeviceType(rowData);
      this.addForm.id = rowData.id;
      this.addForm.workingLevel = rowData.workingLevel;
    },
    showViewDialog(rowData) {
      this.viewDialogVisible = true;
      this.addForm.configName = rowData.configName;
      this.addForm.detailList = rowData.detailList;
      this.addForm.deviceTypeId = this.parseDeviceType(rowData);
      this.addForm.id = rowData.id;
      this.addForm.workingLevel = this.parseLeve(rowData);
      log(this.addForm);
    },
    viewDevice: function (rowData) {
      this.viewDialogVisible = true;
    },
    parseDate: function (rowData) {
      if (rowData.gmtCreate != null) {
        let dateString = commonUtils.timestampToDate(rowData.gmtCreate, true);
        return dateString;
      }
    },
  },
};
</script>

<style scoped>
.delete {
  width: 18px;
  height: 19px;
  background-image: url("../../../static/img/del.png");
  cursor: pointer;
  background-repeat: no-repeat;
}
.delete:hover {
  background-image: url("../../../static/img/del-hover.png");
  background-repeat: no-repeat;
}
.table_searchbar .title11 {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
}
.add_form .title {
  color: #606266;
  font-family: NotoSansHans-Regula;
  font-size: 14px;
  display: inline-block;
  text-align: right;
  width: 70px;
}
.add_form .value {
  display: inline-block;
}
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.table_searchbar {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}
.import_upload {
  display: inline;
}
.page {
  display: flex;
  justify-content: flex-end;
}
@media screen and (max-width: 1380px) {
  .page {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 30px;
  }
}
.total_page {
  margin-top: 20px;
  margin-right: 26px;
  color: #606266;
  font-size: 14px;
}
</style>
<style>
#chechConf .el-form-item--mini.el-form-item,
#chechConf .el-form-item--small.el-form-item {
  margin-top: 8px;
  margin-bottom: 13px;
}
.table_searchbar .el-button--mini,
.el-button--mini.is-round {
  padding: 7px 10px;
}
.el-textarea .el-input__count {
  line-height: 12px;
}
.check-list::before {
  background-color: #fff !important;
}
@media screen and (max-width: 1366px) {
  #chechConf .input-min-width .el-input {
    width: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/devicecare/CheckConf.vue